import { UPDATE_RENT_INCREASE_DOCUMENT } from './../reducers/dashboard';

export function updateRentIncreaseDocument(doc) {
    return {
        type: UPDATE_RENT_INCREASE_DOCUMENT,
        doc
    };
}
